import { useEffect, useMemo, useState } from 'react';
import { claveBorrador, guardarBorrador, hayBorrador, leerBorrador, borrarBorrador } from '../utils/borradores';

// Borrador de un formulario de carga (20-oct-2026). Guarda solo mientras se escribe y, al volver a
// abrir, ofrece seguir donde se dejó (ver utils/borradores).
//   nombre:        clave del formulario ('pedido_borrador')
//   activo:        false al editar algo que ya existe (no hay borrador)
//   estado:        todo lo que hay que recuperar (objeto serializable)
//   conContenido:  (estado) => true si vale la pena guardarlo/ofrecerlo
//   aplicar:       (estado) => vuelve a poner el estado guardado
// Devuelve { ofrecido, seguir, descartar, limpiar }: ofrecido es el borrador liviano (para el aviso).
export default function useBorrador({ nombre, activo = true, estado, conContenido, aplicar }) {
    const clave = useMemo(() => claveBorrador(nombre), [nombre]);
    const [ofrecido, setOfrecido] = useState(() => {
        if (!activo) return null;
        const d = hayBorrador(clave);
        return d && conContenido(d) ? d : null;
    });
    const firma = JSON.stringify(estado);

    useEffect(() => {
        if (!activo || ofrecido) return undefined;   // mientras está el aviso no se pisa lo guardado
        if (!conContenido(estado)) { borrarBorrador(clave); return undefined; }
        const t = setTimeout(() => guardarBorrador(clave, { ...estado, ts: Date.now() }), 400);
        return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [firma, activo, ofrecido, clave]);

    const seguir = async () => {
        const d = await leerBorrador(clave);
        if (d) aplicar(d);
        setOfrecido(null);
    };
    const descartar = () => { borrarBorrador(clave); setOfrecido(null); };
    const limpiar = () => borrarBorrador(clave);

    return { ofrecido, seguir, descartar, limpiar };
}
